<template>
  <div>
    <div class="handle">
      <el-button @click="batchDelete" :disabled="checkArray.length === 0"
        >批量移除</el-button
      ><el-button
        type="primary"
        @click="managePersons"
        >添加调出用户</el-button>
    </div>
    <Table @selection-change="selectChange" :data="currentPersons" />
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="persons.length"
      background
      :hide-on-single-page="currentPersons.length <= 10"
    />
    <person-manage
      @addSucceed="didAddUser"
      :defaultCheckedKeys="persons"
      :showPersonManage="showPersonManage"
      v-if="showPersonManage.flag"
      @closeManage="closeManage"
    />
  </div>
</template>

<script>
import { Confirm } from "@/components/Confirm";
import PersonManage from "./personManage";
import Table from "./table.js";
export default {
  inject: ["form"],
  components: {
    Table,
    PersonManage,
  },
  data() {
    return {
      checkArray: [],
      persons: [],
      currentPage: 1,
      currentSize: 10,
      showPersonManage: { flag: false },
      currentPersons: [],
    };
  },
  methods: {
    closeManage() {
      this.showPersonManage = { flag: false };
    },
    managePersons() {
      this.showPersonManage = { flag: true };
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    didAddUser(persons) {
      this.showPersonManage = { flag: false };
      this.persons = persons;
      this.$emit('changePersons', this.persons)
      this.getCurrentPersons();
    },
    getCurrentPersons() {
      this.currentPersons =  this.persons.slice(
        this.currentSize * (this.currentPage - 1),
        this.currentSize * this.currentPage
      );
    },
    handleSizeChange(size) {
      this.currentSize = size;
      this.getCurrentPersons();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getCurrentPersons();
    },
    // 批量删除人员
    async batchDelete() {
      const text = "确定删除选中用户吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        // 批量删除
        let arrayDifference = (a, b) => {
          // 差集 a - b
          let clone = a.slice(0); // clone = a
          for (let i = 0; i < b.length; i++) {
            let temp = b[i];
            for (var j = 0; j < clone.length; j++) {
              if (temp === clone[j]) {
                clone.splice(j, 1); // remove clone[j]
              }
            }
          }
          return clone;
        };
        let filterData = (array) => {
          // 去重
          return Array.from(new Set(array));
        };
        this.persons = filterData(
          arrayDifference(this.persons, this.checkArray)
        );
        this.$emit('changePersons', this.persons)
        this.getCurrentPersons();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    reset() {
      this.persons = [];
      this.currentPersons = [];
      this.$emit('changePersons', this.persons)
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
